export function toggleMessages(isOpen){
  return (dispatch) => {
    dispatch({type:'TOGGLE_MESSAGES',payload:isOpen})
  }
}